/**
 * DTOs do recurso `holidays` (Feriados).
 * Contrato em `kb-exports/cadastros-gerais/ApiHoliday.spec.md`.
 */

export type FeriadoTipo = 'NAC' | 'EST' | 'MUN' | 'FAC' | 'OUT';

export const FERIADO_TIPOS: ReadonlyArray<{ value: FeriadoTipo; label: string }> = [
  { value: 'NAC', label: 'Nacional' },
  { value: 'EST', label: 'Estadual' },
  { value: 'MUN', label: 'Municipal' },
  { value: 'FAC', label: 'Facultativo' },
  { value: 'OUT', label: 'Outros' },
];

export interface FeriadoDto {
  data: string; // ISO YYYY-MM-DD (PK)
  nome: string;
  tipo: FeriadoTipo;
  ativo: boolean;
  excluidoEm: string | null;
  excluidoPorGuid: string | null;
  excluidoPorNome: string | null;
  criadoEm: string;
  criadoPorGuid: string;
  criadoPorNome: string;
  atualizadoEm: string | null;
  atualizadoPorGuid: string | null;
  atualizadoPorNome: string;
}

export interface FeriadoListItem {
  data: string;
  nome: string;
  tipo: FeriadoTipo;
  ativo: boolean;
}

export interface FeriadoInput {
  data: string; // ISO YYYY-MM-DD
  nome: string;
  tipo: FeriadoTipo;
  ativo?: boolean;
}
